import {useSelector} from "react-redux";

import {TRANSLATES} from "../constants/translates";

export const useTranslate = translates => {
    const activeLang = useSelector(state => state.main.lang);
    let activeTranslates = null;
    if(!translates) {
        return TRANSLATES[activeLang]
    }
    if(Array.isArray(translates)) {
        activeTranslates = {};
        translates.forEach(translate => {
            activeTranslates[translate] = TRANSLATES[activeLang]?.[translate]
        })
    } else {
        activeTranslates = TRANSLATES[activeLang]?.[translates]
    }
    return activeTranslates
}